export default __webpack_public_path__ + "fbd7d137545a3d3cecb05250f8307bf3.png";